import Multiselect from "multiselect-react-dropdown";
import { useContext, useEffect, useRef, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { BsInfoCircle } from "react-icons/bs";
import { RegulationContext } from "../../../../App";
import EmissionVersionFields from "../../../../components/EmissionVersionFields/EmissionVersionFields";
import { CapturedFrequency, LS_AUTHORITY_KEY, USER_ROLE } from "../../../../core/constants/common";
import CompanyService from "../../../../core/service/CompanyService";
import ESGDataSetService from "../../../../core/service/ESGDataSetService";
import FormService from "../../../../core/service/FormService";
import GHGEmissionService from "../../../../core/service/GHGEmissionService";
import KPIService from "../../../../core/service/KPIService";
import StandardService from "../../../../core/service/StandardService";
import Utils from "../../../../core/utilities/Utils";
import LanguageSelector from "../../LanguageSelector/LanguageSelector";
import "./CreateDataPoint.scss";

const CreateDataPoint = ({
  t,
  metricId,
  editDataPointId,
  handleDiscard,
  handleSave,
  editData,
  forESGDataSet = false,
  forKPI = false
}) => {
  const containerRef = useRef(null);
  const [validated, setValidated] = useState(false);
  const [paramname, setParamName] = useState("");
  const [measuringunit, setMeasuringUnit] = useState("");
  const [code, setCode] = useState("");
  const [isEdit, setIsEdit] = useState(editDataPointId ? true : false);
  const [category, setCategory] = useState("");
  const [editId, setEditId] = useState(null);
  const [uomList, setUOMList] = useState([]);
  const [relevantUoms, setRelevantUoms] = useState([]);
  const [inputUOMList, setInputUOMList] = useState([]);
  const [primaryLangName, setPrimaryLangName] = useState();
  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [localizationData, setLocalizationData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isStdTemplateConfig, setIsStdTemplateConfig] = useState(false);
  const [isLanguageAvailable, setIsLanguageAvailable] = useState(false);
  const [emission, setEmission] = useState(false);
  const [selectedScope, setSelectedScope] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [scopeData, setScopeData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [frequency, setFrequency] = useState('');
  const [groups, setGroups] = useState('');
  const [groupsList, setGroupsList] = useState([]);
  const [altText, setAltText] = useState('');
  const [helpText, setHelpText] = useState('');
  const [fileUpload, setFileUpload] = useState(false);
  const [comments, setComments] = useState(false);
  const [applicable, setApplicable] = useState(true);
  const [emissionDatabase, setEmissionDatabase] = useState("");
  const [emissionVersionRef, setEmissionVersionRef] = useState("");
  const { glbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ?? "";
  const companyId = authority?.profile?.company?.id;

  useEffect(() => {
    getGroupsList();
  }, [])
  useEffect(() => {
    // containerRef.current.scrollIntoView();
    if (window.location.href.includes('std_template_config')) {
      setIsStdTemplateConfig(true);
    }
    setCode("");
    setParamName("");
    setMeasuringUnit("");
    setCategory("");
    setValidated(false);
    setIsEdit(editDataPointId ? true : false);
    let lsAuthorityData = JSON.parse(localStorage.getItem("authority"));
    if (lsAuthorityData.roles.includes(USER_ROLE.SUPER_ADMIN) && editDataPointId) {
      setIsLanguageAvailable(false);
      getDetails(editDataPointId, false);
    } else {
      getCompanyLanguages(editDataPointId);
    }
    if (!editDataPointId) {
      setIsLoaded(true);
    }


  }, [isStdTemplateConfig, editDataPointId]);

  useEffect(() => {
    getDetailsOfTable();
  }, []);

  useEffect(() => {
    if (editDataPointId && editData && typeof editData.emission !== 'undefined') {
      let lsAuthorityData = JSON.parse(localStorage.getItem("authority"));
      getDetails(editDataPointId, lsAuthorityData.roles.includes(USER_ROLE.SUPER_ADMIN) ? false : isLanguageAvailable);
    } else if (!editDataPointId) {
      setIsLoaded(true);
    } else if (editDataPointId && !editData) {
      setIsLoaded(false);
    }
  }, [editDataPointId, isLanguageAvailable, isStdTemplateConfig, editData]);

  const getCompanyLanguages = (editDPId) => {
    CompanyService.getCompanyLanguageList()
      .then((response) => {
        let isLangAvail = false;
        if (response.status === 200) {
          if (Array.isArray(response.data) && response.data.length > 0) {
            isLangAvail = true;
            setIsLanguageAvailable(isLangAvail);
          } else {
            setIsLanguageAvailable(isLangAvail);
          }
        }
        editDPId && getDetails(editDataPointId, isLangAvail);
      })
      .catch((error) => { });
  }
  const getGroupsList = () => {
    FormService.listGroups()
      .then((response) => {
        if (response.status === 200) {
          // Transform the response to use groupName as both label and value
          const transformedGroups = response.data.map((group) => ({
            id: group.id,
            label: group.groupName,
            value: group.groupName
          }));
          setGroupsList(transformedGroups);
        }
      })
      .catch((error) => { });
  }
  const handleScopeChange = (e) => {
    const scopeName = e.target.value;
    setSelectedScope(scopeName);
    setSelectedCategory("");
    const selectedScopeData = scopeData.find((scope) => scope.name === scopeName);
    setCategoryData(
      selectedScopeData?.categories?.map((cat) => cat.name) ?? []
    );
  };
  const saveData = (e) => {
    e.preventDefault();
    const params = {
      unitOfMeasure: measuringunit,
      code: code,
      metricId: metricId,
      relevantUoms: relevantUoms,
      emission: emission,
      scope: emission ? selectedScope : "",
      scopeCategory: emission ? selectedCategory : "",
      emissionDatabase: emission ? emissionDatabase : "",
      emissionVersionRef: emission ? emissionVersionRef : "",
      frequency: frequency ?? null,
      groups: groups ?? null,
      altText: altText || null,
      helpText: helpText || null,
      fileUpload: fileUpload,
      comments: comments,
      applicable: applicable,
      status: true
    };

    if (measuringunit && code) {
      if (!validateEmissionFields()) {
        setValidated(true);
        return;
      }

      let req;
      if (forKPI) {
        const dpPayload = {
          ownerId: authority.profile.company.id,
          name: params.name,
          code: params.code,
          unitOfMeasure: params.unitOfMeasure,
          uoms: params.relevantUoms,
          emission: params.emission,
          scope: params.scope,
          scopeCategory: params.scopeCategory,
          emissionDatabase: params.emissionDatabase,
          emissionVersionRef: params.emissionVersionRef,
          frequency: params.frequency ?? null,
          groups: params.groups ?? null,
          altText: params.altText,
          helpText: params.helpText,
          fileUpload: params.fileUpload,
          comments: params.comments,
          applicable: params.applicable,
          status: true
        };
        req = KPIService.createKPIDatapoint(dpPayload);
      } else if (forESGDataSet) {
        params.name = paramname.trim()
        req = ESGDataSetService.addDP(metricId, params);
      } else if (isStdTemplateConfig || !isLanguageAvailable) {
        params.name = paramname.trim();
        req = StandardService.addDataPoint(params, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      } else {
        params.name = primaryLangName.trim();
        params.localizedContents = localizationData;
        req = StandardService.addDataPoint(params, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      }
      if (!(params.name)) {
        setValidated(true);
        return;
      }
      req.then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setCode("");
          setParamName("");
          setMeasuringUnit("");
          setCategory("");
          setValidated(false);
          setEmission(false);
          setSelectedScope("");
          setSelectedCategory("");
          setEmissionDatabase("");
          setEmissionVersionRef("");
          setGroups('');
          setFrequency('');
          setAltText('');
          setHelpText('');
          setFileUpload(false);
          setComments(false);
          setApplicable(true);
          handleSave(metricId);
        }
      })
        .catch((error) => { });
    }
    setValidated(true);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    const params = {
      // category: category,
      unitOfMeasure: measuringunit,
      code: code,
      metricId: metricId,
      relevantUoms: relevantUoms,
      emission: emission,
      scope: emission ? selectedScope : "",
      scopeCategory: emission ? selectedCategory : "",
      emissionDatabase: emission ? emissionDatabase : "",
      emissionVersionRef: emission ? emissionVersionRef : "",
      frequency: frequency ?? null,
      groups: groups ?? null,
      altText: altText || null,
      helpText: helpText || null,
      fileUpload: fileUpload,
      comments: comments,
      applicable: applicable
    };
    if (paramname && measuringunit && code) {
      if (!validateEmissionFields()) {
        setValidated(true);
        return;
      }
      let req;
      if (forESGDataSet) {
        params.name = paramname.trim()
        params.id = editId;
        req = ESGDataSetService.updateDP(params);
      } else if (isStdTemplateConfig || !isLanguageAvailable) {
        params.name = paramname.trim();
        req = StandardService.updateDataPoint(params, editId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      } else {
        params.name = primaryLangName.trim();
        params.localizedContents = localizationData;
        req = StandardService.updateDataPoint(params, editId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
      }
      req.then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setValidated(false);
          handleSave(metricId);
        }
      })
        .catch((error) => { });
    }
    setValidated(true);
  };
  const closeMetric = (e) => {
    e.preventDefault();
    handleDiscard(true);
  };
  const getDetails = (editId, isLangAvail) => {
    if (editData?.localizedContents && editData?.localizedContents.length > 0) {
      setLocalizationData(editData?.localizedContents);
    } else if (!isStdTemplateConfig && isLangAvail) {
      const objLocal = {
        fieldName: 'name',
        languageCode: "",
        translatedValue: editData?.name
      }
      setLocalizationData([objLocal]);
    }

    setParamName(editData.name);
    setMeasuringUnit(editData.unitOfMeasure);
    setCode(editData.code);
    setEditId(editData.id);
    setRelevantUoms(editData.relevantUoms ?? []);
    setGroups(editData.groups);
    setFrequency(editData.frequency);
    setAltText(editData.altText || '');
    setHelpText(editData.helpText || '');
    setFileUpload(editData.fileUpload || false);
    setComments(editData.comments || false);
    setApplicable(editData.applicable !== false);

    setEmissionDatabase(editData.emissionDatabase || editData.database || "");
    setEmissionVersionRef(editData.emissionVersionRef || editData.versionRef || "");
    setEmission(editData.emission || false);

    if (editData.emission) {
      setSelectedScope(editData.scope || "");
      setSelectedCategory(editData.scopeCategory || "");
      const db = editData.emissionDatabase || editData.database;
      const versionRef = editData.emissionVersionRef || editData.versionRef;
      if (versionRef && db) {
        GHGEmissionService.getVersionScopeDetails(versionRef, db)
          .then((response) => {
            if (response.status === 200) {
              const scopeList = response.data?.data ?? response.data ?? [];
              setScopeData(Array.isArray(scopeList) ? scopeList : []);
              const selectedScopeData = scopeList.find((scope) => scope.name === editData.scope);
              if (selectedScopeData?.categories) {
                setCategoryData(selectedScopeData.categories.map((cat) => cat.name)
                );
              }
            }
          })
          .catch(() => { });
      }
    }

    setIsLoaded(true);
  };
  const getDetailsOfTable = () => {
    StandardService.getUnitsOfMeasure()
      .then((response) => {
        if (response.status !== 200) return;

        const outputList = [], inputList = [];
        for (let index = 0; index < response.data.data.length; index++) {
          const element = response.data.data[index];
          outputList.push({
            id: element.id,
            label: element.outputUnitName,
            value: element.outputUnit
          });
          inputList.push({
            id: element.id,
            label: element.inputUnitName,
            value: element.inputUnit
          });
        }
        const uniqueOutputArray = Array.from(new Set(outputList.map(obj => obj.value))).map(
          value => outputList.find(obj => obj.value === value)
        );
        uniqueOutputArray.sort((a, b) => a.value.localeCompare(b.value));
        const uniqueInputArray = Array.from(new Set(inputList.map(obj => obj.value))).map(
          value => inputList.find(obj => obj.value === value)
        );
        uniqueInputArray.sort((a, b) => a.value.localeCompare(b.value));
        setUOMList(uniqueOutputArray);
        setInputUOMList(uniqueInputArray);
      })
      .catch((error) => { });
  }

  const onSelectDeSelectUoms = (selectedItem) => {
    const uoms = [...relevantUoms];
    const index = relevantUoms.indexOf(selectedItem.value);
    if (index >= 0) {
      uoms.splice(index, 1);
    } else {
      uoms.push(selectedItem.value);
    }
    setRelevantUoms(uoms);
  };

  const getSelectedUoms = (uoms) => {
    const data = [];
    uoms?.forEach(uom => {
      const match = inputUOMList.find(u => u.value === uom);
      if (!match) return;

      data.push(match);
    });
    return data;
  };

  const convertedDataVal = (data, nameVal) => {
    setPrimaryLangName(nameVal);
    setLocalizationData(data);
  }

  const resetEmissionScopeSelection = () => {
    setSelectedScope("");
    setSelectedCategory("");
    setCategoryData([]);
    setScopeData([]);
  };

  const handleEmissionConfigChange = (config) => {
    setEmissionDatabase(config.database || "");
    setEmissionVersionRef(config.versionRef || "");
  };

  const handleEmissionToggle = () => {
    if (emission) {
      resetEmissionScopeSelection();
      setEmissionDatabase("");
      setEmissionVersionRef("");
    }
    setEmission(!emission);
  };

  const validateEmissionFields = () => {
    if (!emission) return true;
    if (!emissionDatabase || !emissionVersionRef || !selectedScope || !selectedCategory) {
      toast.error(t("EmissionFieldsRequired.label"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    return true;
  };

  if (!isLoaded) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <div className="create_datapointCard" id="idMetric" ref={containerRef}>
        <Form noValidate validated={validated}>
          <div className="row m-0">
            {(forESGDataSet || isStdTemplateConfig || !isLanguageAvailable) ? <div className="col-lg-12 p-0">
              <label className="mb-1">{t("DataPoint.label")} <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={paramname}
                onChange={(e) => setParamName(e.target.value)}
                required
                maxLength={250}
              />
            </div>
              : <div className="col-lg-12 p-0">
                <LanguageSelector fieldLabel={t("DataPoint.label")} convertedData={(data, nameVal) => convertedDataVal(data, nameVal)} localizationData={localizationData} />
              </div>}

            {/* <div className="col-lg-3 p-2">
                <label className="mb-1">{t("Category.label")}</label>&nbsp;*
                <select
                  className="form-select"
                  required
                  onChange={(e) => setCategory(e.target.value)}
                  value={category}
                >
                  <option value="" disabled hidden>
                    {t("Select.label")}
                  </option>
                  {categoryOptions?.map((items) => (
                    <option value={items.value} key={items.value}>
                      {items.label}
                    </option>
                  ))}
                </select>
              </div> */}
            <div className="col-lg-6 p-2">
              <label className="mb-1">{t("MeasuringUnit.label")} <span className="text-danger">*</span></label>
              {
                uomList?.length > 0 &&
                <Typeahead
                  id="measuringUnit"
                  key="measuringUnit"
                  clearButton
                  selected={uomList?.filter(u => u.value === measuringunit)}
                  labelKey={(option) => option.label}
                  onChange={(selected) => {
                    if (selected.length > 0) {
                      setMeasuringUnit(selected[0].value);
                    } else {
                      setMeasuringUnit('');
                    }
                  }}
                  options={uomList}
                  placeholder={t("Search.label")} />
              }
            </div>
            <div className="col-lg-6 p-2">
              <label className="mb-1">{t("Code.label")} <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                maxLength={250}
              />
            </div>
            <div className="col-lg-12 p-2">
              <label className="mb-1">
                {t("PossibleUOMs.label")}
              </label>
              <Multiselect
                id="uomMultiselect"
                key="uomMultiselect"
                options={inputUOMList}
                selectedValues={getSelectedUoms(relevantUoms)}
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                displayValue="label"
              />
            </div>
            <div className="col-lg-12 p-2">
              <div className="row">
                <div className="col-lg-12">
                  <div className="mt-3">
                    <input className="form-check-input" type="checkbox"
                      id='emissionCheckbox'
                      checked={emission}
                      onChange={handleEmissionToggle} />
                    <label className="form-check-label mx-1" htmlFor='emissionCheckbox'>
                      {t("Emission.label")}
                    </label>
                  </div>
                </div>
                {emission && (
                  <div className="col-lg-12 mt-2 emission-config-section">
                    <EmissionVersionFields
                      key={`${editDataPointId}-${editData?.emissionDatabase || editData?.database || ""}-${editData?.emissionVersionRef || ""}`}
                      companyId={companyId}
                      glbRegulationId={glbRegulationId}
                      editDatabase={isEdit ? (editData?.emissionDatabase || editData?.database || "") : ""}
                      editVersionRef={isEdit ? (editData?.emissionVersionRef || editData?.versionRef || "") : ""}
                      onScopeDataChange={setScopeData}
                      onScopeCategoryReset={resetEmissionScopeSelection}
                      onConfigChange={handleEmissionConfigChange}
                    />
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="mb-1">{t("Scope.label")}</label>&nbsp;*
                        <select
                          className="form-select"
                          value={selectedScope}
                          onChange={handleScopeChange}
                          required
                          disabled={!emissionVersionRef}>
                          <option value="">{t("Select.label")}</option>
                          {scopeData.map((scope) => (
                            <option key={scope.name} value={scope.name}>
                              {scope.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="mb-1">{t("Category.label")}</label>&nbsp;*
                        <select
                          className="form-select"
                          value={selectedCategory}
                          onChange={(e) => setSelectedCategory(e.target.value)}
                          required
                          disabled={!selectedScope}>
                          <option value="">{t("Select.label")}</option>
                          {categoryData.map((category) => (
                            <option key={category} value={category}>
                              {category}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <label className="mb-1 mt-2">{t("Frequency.label")} <span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                    required>
                    <option value="">{t("Select.label")}</option>
                    <option value={CapturedFrequency.MONTHLY} key={CapturedFrequency.MONTHLY}>{t("MONTHLY.label")}</option>
                    <option value={CapturedFrequency.QUARTERLY} key={CapturedFrequency.QUARTERLY}>{t("QUARTERLY.label")}</option>
                    <option value={CapturedFrequency.HALF_YEARLY} key={CapturedFrequency.HALF_YEARLY}>{t("HALF_YEARLY.label")}</option>
                    <option value={CapturedFrequency.YEARLY} key={CapturedFrequency.YEARLY}>{t("Yearly.label")}</option>                    
                  </select>
                </div>
                <div className="col-lg-6">
                  <label className="mb-1 mt-2">{t("AssignedGroups.label")}</label>
                  {
                    groupsList?.length > 0 ? (
                      <Typeahead
                        id="assignedGroups"
                        key="assignedGroups"
                        clearButton
                        selected={groupsList?.filter(g => g.value === groups)}
                        labelKey={(option) => option.label}
                        onChange={(selected) => {
                          if (selected.length > 0) {
                            setGroups(selected[0].value);
                          } else {
                            setGroups('');
                          }
                        }}
                        options={groupsList}
                        placeholder={t("Search.label")} />
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        value=""
                        disabled
                        placeholder={t("Loading.label") || "Loading..."}
                      />
                    )
                  }
                </div>
              </div>
            </div>
            <div className="col-lg-12 p-2">
              <div className="d-flex align-items-center mb-1">
                <label className="mb-0">{t("AltText.label")}</label>
                <OverlayTrigger
                  placement="top"
                  overlay={Utils.renderTooltip(t("AltText.tooltip.label"))}
                >
                  <span className="ms-1">
                    <BsInfoCircle />
                  </span>
                </OverlayTrigger>
              </div>
              <input
                type="text"
                className="form-control"
                value={altText}
                onChange={(e) => setAltText(e.target.value)}
                maxLength={500}
                placeholder={t("AltText.placeholder.label") || "Enter alt text"}
              />
            </div>
            <div className="col-lg-12 p-2">
              <div className="d-flex align-items-center mb-1">
                <label className="mb-0">{t("HelpText.label")}</label>
                <OverlayTrigger
                  placement="top"
                  overlay={Utils.renderTooltip(t("HelpText.tooltip.label"))}
                >
                  <span className="ms-1">
                    <BsInfoCircle />
                  </span>
                </OverlayTrigger>
              </div>
              <textarea
                className="form-control"
                value={helpText}
                onChange={(e) => setHelpText(e.target.value)}
                rows={3}
                maxLength={1000}
                placeholder={t("HelpText.placeholder.label") || "Enter help text"}
              />
            </div>
            <div className="col-lg-12 p-2">
              <div className="mt-3 d-flex align-items-center">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="notApplicableCheckbox"
                  checked={!applicable}
                  onChange={(e) => setApplicable(!e.target.checked)}
                />
                <label className="form-check-label mx-1 mb-0" htmlFor="notApplicableCheckbox">
                  {t("NotApplicable.label")}
                </label>
                <OverlayTrigger
                  placement="top"
                  overlay={Utils.renderTooltip(t("NotApplicable.tooltip.label"))}
                >
                  <span className="ms-1">
                    <BsInfoCircle />
                  </span>
                </OverlayTrigger>
              </div>
            </div>
            <div className="col-lg-12 p-2">
              <div className="row">
                <div className="col-lg-6">
                  <div className="mt-3 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="fileUploadCheckbox"
                      checked={fileUpload}
                      onChange={() => setFileUpload(!fileUpload)}
                    />
                    <label className="form-check-label mx-1 mb-0" htmlFor="fileUploadCheckbox">
                      {t("FileUpload.label")}
                    </label>
                    <OverlayTrigger
                      placement="top"
                      overlay={Utils.renderTooltip(t("FileUpload.tooltip.label"))}
                    >
                      <span className="ms-1">
                        <BsInfoCircle />
                      </span>
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mt-3 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="commentsCheckbox"
                      checked={comments}
                      onChange={() => setComments(!comments)}
                    />
                    <label className="form-check-label mx-1 mb-0" htmlFor="commentsCheckbox">
                      {t("Comments.label")}
                    </label>
                    <OverlayTrigger
                      placement="top"
                      overlay={Utils.renderTooltip(t("Comments.tooltip.label"))}
                    >
                      <span className="ms-1">
                        <BsInfoCircle />
                      </span>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 p-2 text-center">
              <button
                className="btn btn-secondary me-2 px-3"
                onClick={closeMetric}
              >
                {" "}
                {t("Discard.label")}
              </button>
              {isEdit ? (
                <button
                  className="btn btn-primary px-4"
                  onClick={handleEdit}
                >
                  {" "}
                  {t("Save.label")}
                </button>
              ) : (
                <button className="btn btn-primary px-4" onClick={saveData}>
                  {" "}
                  {t("Save.label")}
                </button>
              )}
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default withTranslation()(CreateDataPoint);
